export default __webpack_public_path__ + "static/media/shape1.77200469.png";